import Immutable from 'immutable';
import { createStructuredSelector } from 'reselect';

import ApiService from 'services/ApiService/ApiService';
import { convertTokensToDollars } from 'utils/helpers';

import {
  STUDIO_REVENUE_INSIGHTS,
  YEAR_REVENUE_URL_REPORTING,
} from './Api';


const STUDIO_REVENUE = 'cam4/studio/STUDIO_REVENUE';
const YEAR_REVENUE = 'cam4/studio/YEAR_REVENUE';

const initialState = Immutable.fromJS({
  studioRevenue: [],
  yearRevenue: [],
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case STUDIO_REVENUE:
      return state.set('studioRevenue', Immutable.fromJS(action.studioRevenue));
    case YEAR_REVENUE:
      return state.set('yearRevenue', Immutable.fromJS(action.yearRevenue));

    default:
      return state;
  }
}

export const NAME = 'studioRevenue';

const studioRevenue = (state) => state[NAME].get('studioRevenue');
const yearRevenue = (state) => state[NAME].get('yearRevenue');

export const selector = createStructuredSelector({
  studioRevenue,
  yearRevenue,
});

function displayStudioRevenue(data) {
  return {
    type: STUDIO_REVENUE,
    studioRevenue: data,
  };
}

function displayYearRevenue(data) {
  return {
    type: YEAR_REVENUE,
    yearRevenue: data,
  };
}

function parseStudioRevenueResults(res) {
  const data = [];
  let counter = 0;
  if (Array.isArray(res?.data)) {
    res.data.forEach((n) => {
      data[counter] = n;
      data[counter].amount = convertTokensToDollars(n.amount);
      data[counter].id = counter;
      data[counter].key = counter;
      data[counter].amountPerHour = convertTokensToDollars(
        data[counter].hours ? (data[counter].amount / data[counter].hours).toFixed(2) : 0
      );
      counter += 1;
    });
  }

  return (dispatch) => {
    dispatch(displayStudioRevenue(data));
  };
}

function parseYearRevenueResults(res) {
  const data = [];
  let counter = 0;
  if (Array.isArray(res?.data)) {
    res.data.forEach((n) => {
      data[counter] = n;
      data[counter].amount = convertTokensToDollars(n.amount);
      data[counter].id = counter;
      data[counter].key = counter;
      data[counter].amountPerHour = convertTokensToDollars(
        data[counter].hours ? (data[counter].amount / data[counter].hours).toFixed(2) : 0
      );
      counter += 1;
    });
  }

  return (dispatch) => {
    dispatch(displayYearRevenue(data));
  };
}

function getStudioRevenue(username, date) {
  const [startDate, endDate] = date;
  const url = ApiService.substitute(
    STUDIO_REVENUE_INSIGHTS,
    { username, startDate, endDate }
  );

  return (dispatch) => ApiService.get(url)
    .then((res) => dispatch(parseStudioRevenueResults(res)));
}

function getYearRevenue(username) {
  const url = ApiService.substitute(
    YEAR_REVENUE_URL_REPORTING,
    { username }
  );

  return (dispatch) => ApiService.get(url)
    .then((res) => dispatch(parseYearRevenueResults(res)));
}

export const actionCreators = {
  getStudioRevenue,
  getYearRevenue,
};
